import './plugins';

export default {};
